import { App } from 'vue';
import vSizeDirective from './src/size.ts';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vSizeDirective as vSize };
